import type { ITeamRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import type { EffectiveSoftwareVersionContextConfiguration, EffectiveStorageContextConfiguration } from "@domain/schemas/BI";
import type { MyTeam, TeamProjectInventoryItem } from "@domain/schemas/workspace";

@injectable()
export class ListTeamsService {
  @inject(TYPES.ITeamRepository)
  private _teamRepository!: ITeamRepository;

  async getMyTeamsAsync(): Promise<MyTeam[]> {
    return this._teamRepository.getMyTeamsAsync();
  }

  async getTeamProjectInventoryAsync(teamId: string): Promise<TeamProjectInventoryItem[]> {
    return this._teamRepository.getTeamProjectInventoryAsync(teamId);
  }

  async getEffectiveSoftwareVersionConfigurationAsync(teamId: string): Promise<EffectiveSoftwareVersionContextConfiguration> {
    return this._teamRepository.getEffectiveSoftwareVersionConfigurationAsync(teamId);
  }

  async getEffectiveStorageConfigurationAsync(teamId: string): Promise<EffectiveStorageContextConfiguration> {
    return this._teamRepository.getEffectiveStorageConfigurationAsync(teamId);
  }
}
